import { axios } from '@/utils/http'
import { UploadResult } from '@/models/exam'

export async function post(
  url: string,
  file: File,
  onUploadProgress?: (progressEvent: any) => void
) {
  const form = new FormData()
  form.append('sheet', file, file.name)
  form.append('name', file.name)

  const { data } = await axios.post(url, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress
  })
  return data as UploadResult
}

export async function postDoc(
  url: string,
  file: File,
  onUploadProgress?: (progressEvent: any) => void
) {
  const form = new FormData()
  form.append('file', file, file.name)
  form.append('name', file.name)

  const { data } = await axios.post(url, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress
  })
  return data as UploadResult
}
